/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  HousePlanBulkUpdateDto,
  HousePlanFilterDto,
  PbHousePlanDto,
} from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';

export type HousePlanFinderListItem = HousePlanBulkUpdateDto;
export type HousePlanFinderFilter = HousePlanFilterDto;

export type PbHousePlanFinderListItem = PbHousePlanDto;
export type PbHousePlanFinderFilter = {
  isSalesEstimate: boolean;
  isQuickQuote: boolean;
  allowQq: boolean;
  searchString: string;
  priceBookId: ID;
};

export const DEFAULT_HOUSE_PLAN_FILTER = {
  searchString: '',
  quickQuote: false,
  salesEstimate: false,
};

export const getHousePlanId = (housePlan: HousePlanFinderListItem) => housePlan.housePlanId;
export const getPbHousePlanId = (hp: PbHousePlanFinderListItem) => hp.housePlanId;
